<template>
  <v-container>
    <h1 class="mb-4">Switch Orders</h1>
    <v-card>
      <v-tabs v-model="tab" class="px-4 pt-4">
        <v-tab>Dashboard</v-tab>
        <v-tab>Details</v-tab>
        <v-tab>Explorer</v-tab>
        <v-tab>OTOs</v-tab>
        <v-tab>Review</v-tab>
        <v-tab>Proof of Concept</v-tab>
        <v-tab>Background</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-card-text>
        <v-tabs-items v-model="tab">
          <!-- ---------------------- Dashboard ---------------------- -->
          <v-tab-item>
            <SwitchOrdersDashboard />
          </v-tab-item>
          <!-- ---------------------- Details ---------------------- -->
          <v-tab-item>
            <SwitchOrdersDetails />
          </v-tab-item>
          <!-- ---------------------- Explorer ---------------------- -->
          <v-tab-item>
            <SwitchOrdersExplorer />
          </v-tab-item>
          <!-- ---------------------- OTOs ---------------------- -->
          <v-tab-item>
            <SwitchOrdersOTOs />
          </v-tab-item>
          <!-- ---------------------- Review ---------------------- -->
          <v-tab-item>
            <SwitchOrdersReview />
          </v-tab-item>
          <!-- ---------------------- Proof of Concept ---------------------- -->
          <v-tab-item>
            <SwitchOrdersConcept />
          </v-tab-item>
          <!-- ---------------------- Background ---------------------- -->
          <v-tab-item>
            <SwitchOrdersBackground />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import SwitchOrdersDashboard from "@/components/Operations/SwitchOrdersDashboard.vue";
import SwitchOrdersBackground from "@/components/Operations/SwitchOrdersBackground.vue";
import SwitchOrdersConcept from "@/components/Operations/SwitchOrdersConcept.vue";
import SwitchOrdersReview from "@/components/Operations/SwitchOrdersReview.vue";
import SwitchOrdersOTOs from "@/components/Operations/SwitchOrdersOTOs.vue";
import SwitchOrdersDetails from "@/components/Operations/SwitchOrdersDetails.vue";
import SwitchOrdersExplorer from "@/components/Operations/SwitchOrdersExplorer.vue";
export default {
  name: "SwitchOrders",
  components: {
    SwitchOrdersBackground,
    SwitchOrdersConcept,
    SwitchOrdersReview,
    SwitchOrdersOTOs,
    SwitchOrdersDashboard,
    SwitchOrdersDetails,
    SwitchOrdersExplorer,
  },
  data() {
    return {
      tab: 0,
    };
  },
};
</script>